import clsx from "clsx";

const Header = ({ children, className }: { children: React.ReactNode; className?: string }) => {
  return (
    <div
      className={clsx(
        className,
        "flex items-center justify-between border-b border-solid border-25 p-[12px]"
      )}
    >
      {children}
    </div>
  );
};

const Title = ({ children, className }: { children: React.ReactNode; className?: string }) => {
  return (
    <div className={clsx(className, "text-[16px] font-medium leading-[150%] text-white")}>
      {children}
    </div>
  );
};

const ModalPanel = {
  Header: Header,
  Title: Title,
};

export default ModalPanel;
